import { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';

type Props = {
	label: string;
	value?: number | string | null;
};

export const PersonaDetailBio: FC<Props> = ({ label, value }) => {
	const theme = useTheme();

	return value ? (
		<Grid container justifyContent={'start'} alignItems={'start'} textAlign={'left'}>
			<Grid item xs={5}>
				<Typography variant={'inherit'} fontSize={'14px'} fontWeight={'400'} color={theme.palette.grey[500]}>
					{label}
				</Typography>
			</Grid>
			<Grid item xs={7}>
				<Typography variant={'inherit'} fontSize={'14px'} fontWeight={'500'} color={theme.palette.grey[700]}>
					{value}
				</Typography>
			</Grid>
		</Grid>
	) : null;
};
